export enum THGCarPayoffModel {
    FIX = 'fix',
    FLEX = 'flex',
    EXPRESS = 'express',
    COMBI_FIX = 'combi-fix',
    COMBI_EXPRESS = 'combi-express',
}

export interface THGCarCombiPayoffAmount {
    default: number;
    years: number[];
}

export interface THGCarFixPayoffAmount {
    default: number;
    first?: number;
}

export interface THGCarFlexPayoffAmount {
    min: number;
    max: number;
}
